export class User{
    Id:number;
    login:string;
    pass:string;
}